import React from 'react';
import {
	CallFieldMappingConfig,
	CallLogData,
	DateCallFieldMappingConfig, DirectionCallFieldMappingConfig, ParticipantNameCallFieldMappingConfig
} from '../../store/state/createJobState';
import DateMappingConfigurationModal from './DateMappingConfigurationModal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/actions/appDispatch';
import DirectionMappingConfigurationModal from './DirectionMappingConfigurationModal';
import ParticipantNameMappingConfigurationModal from './ParticipantNameMappingConfigurationModal';
import { getColumnIndexesForMappingConfig } from '../../store/selectors/createJobSelectors';

export default function MappingConfigurationModal(props: Props) {
	const dispatch = useDispatch<AppDispatch>();
	const data = props.configurationData;
	
	if (data.type === 'date') {
		return <DateMappingConfigurationModal logColumnIndex={data.logColumnIndex} 
											  mappingConfig={data.config}
											  callLogData={props.callLogData} 
											  onCancel={props.onDone} 
											  onConfigured={onConfigured}  />
	}
	
	if (data.type === 'direction') {
		return <DirectionMappingConfigurationModal config={data.config}
												   allocatedColumnIndexes={getAllocatedColumnIndexes()}
												   callLogData={props.callLogData}
												   hideColumnSelector={data.hideColumnSelector}
												   hideModeSelector={data.hideModeSelector}
												   onCancel={props.onDone}
												   onConfigured={onConfigured}  />
	}
	
	if (data.type === 'participantName') {
		return <ParticipantNameMappingConfigurationModal config={data.config} 
														 allocatedColumnIndexes={getAllocatedColumnIndexes()}
														 callLogData={props.callLogData} 
														 onCancel={props.onDone} 
														 onConfigured={onConfigured} />
	}
	
	return null;
	
	function onConfigured(config: CallFieldMappingConfig): void  {
		dispatch({ 
			type: 'create-job/update-call-field-mapping-config', 
			config,
			engagementId: props.engagementId
		});
		
		props.onDone();
	}
	
	function getAllocatedColumnIndexes(): Set<number> {
		const result: Set<number> = new Set();
		
		props.mappings.forEach(m => {
			getColumnIndexesForMappingConfig(m).forEach(i => {
				result.add(i);
			});
		});
		
		return result;
	}
}

interface Props {
	configurationData: MappingConfigurationModalData;
	engagementId: number;
	callLogData: CallLogData;
	mappings: CallFieldMappingConfig[];
	onDone: () => void;
}

export interface MappingConfigurationModalDateData {
    type: 'date';
    config: DateCallFieldMappingConfig;
	logColumnIndex: number;
}

export interface MappingConfigurationModalDirectionData {
    type: 'direction';
	config: DirectionCallFieldMappingConfig;
	hideColumnSelector?: boolean;
	hideModeSelector?: boolean;
}

export interface MappingConfigurationModalParticipantNameData {
    type: 'participantName';
	config: ParticipantNameCallFieldMappingConfig;
}

export type MappingConfigurationModalData = MappingConfigurationModalDateData | MappingConfigurationModalDirectionData | MappingConfigurationModalParticipantNameData;
